import React, { Component } from 'react'
import { Row, Col, Divider, Card, Icon } from 'antd';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faUser from '@fortawesome/fontawesome-free-solid/faUser'
import {
  faGithub,
} from '@fortawesome/fontawesome-free-brands'
import axios from 'axios'

class Github extends Component {
  state = {
    data: []
  }
  componentDidMount = async () => {
    const { data } = await this.getRespos()
    this.setState({
      data
    })
  }

  getRespos = async() => {
    const url = 'https://api.github.com/users/pozterz/repos'
    return await axios.get(url)
  } 
  
  render(){
    const { data } = this.state
    console.log(data)
    return (
      <div className="container white-text">
        <h3> <FontAwesomeIcon icon={faGithub} /> GITHUB REPOSITORIES </h3>
        <Divider />
        <Row gutter={16} type="flex" justify="center" align="top" className="mt-5">
          { data.map(repo => {
            return (
              <Col key={repo.id} md={6} className="w-sm-100">
                <Card title={repo.name} extra={repo.fork ? <Icon type="fork" /> : ''} bordered={false} className="mb-3">
                  <Icon type="fork" /> { repo.forks_count }  <Icon type="star-o" /> { repo.stargazers_count }
                </Card>
              </Col>
            )
          })}
        </Row>
      </div>
    );
  }
}


export default Github


// WEBPACK FOOTER //
// ./src/components/Github.js